window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600
  }
});

const isCustomerPortal = window.location.pathname.includes("/tools/bundle-subscriptions") && window.location.search.includes("subscriptionId=");
const isBaBPurchaseFlow = window.location.pathname.includes("/tools/bundle-subscriptions/bundle/");

const waitForElement = (selector, callback, delay = 0, failsafeDelay) => {
  const observer = new MutationObserver((mutations, obs) => {
    const element = document.querySelector(selector);
    if (element) {
      obs.disconnect();
      if (typeof callback === "function") {
        setTimeout(() => {
          callback(element);
        }, delay);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (failsafeDelay) setTimeout(() => observer.disconnect(), failsafeDelay);
};

const haveTwoOrMoreOrders = () => {
  const successfulBillingAttempts =
    window.Awtomic.subscriptionBillingAttempts.filter(
      (ba) => ba.BillingAttemptStatus == "SUCCESS"
    );

  const originOrderExists = !!window.Awtomic.subscriptionOriginOrder?.createdAt
    ? 1
    : 0;
  return successfulBillingAttempts.length + originOrderExists >= 2;
};

const hideCancelButton = () => {
  const cancelButton = document.querySelector(
    "#bundleapp-subscriptions-root button.bundle-button--cancel"
  );
  if (cancelButton) {
    cancelButton.setAttribute("disabled", "true");
    cancelButton.classList.add("disabled");
    cancelButton.style.display = "none";
    cancelButton.style.cursor = "not-allowed";
  }
};

window.addEventListener("awtomic-cp-loaded", ({ detail } = {}) => {
  setTimeout(() => {
    if (!haveTwoOrMoreOrders()) {
      hideCancelButton();
    }
  }, 200);
  if (!haveTwoOrMoreOrders()) {
    hideCancelButton();
  }
});

